import PropTypes from 'prop-types';
import TextTransition from 'react-text-transition';
import List from './List';
import Button from './ui/Button';
import Link from './ui/Link';
import Select from './ui/Select';

export default function Plan({
	bottomLink = {},
	buttonLabel = '',
	description = '',
	featureHeading = '',
	featureListItems = [],
	highlight = '',
	loading = false,
	onButtonClick = () => {},
	price = '',
	priceExplanation = '',
	priceInterval = '',
	pricePerUnit = '',
	unitSelect = { label: '', onChange: () => {}, options: [], selected: '' },
}) {
	const wrapperClasses = ['prc-plan'];
	highlight && wrapperClasses.push('prc-plan--most-popular');

	const skeletonAttributes = {};
	loading && (skeletonAttributes['data-loading'] = loading);

	return (
		<div className={wrapperClasses.join(' ')}>
			{highlight && <div className="prc-plan__badge">{highlight}</div>}

			<div className="prc-plan__actions">
				<div className="prc-plan__price">
					<h3 className="total" {...skeletonAttributes}>
						<TextTransition inline={true}>{price}</TextTransition>
					</h3>
					<span className="interval">{priceInterval}</span>
					<span className="explanation">{priceExplanation}</span>
					{pricePerUnit && <div className="price-per-unit">{pricePerUnit}</div>}
				</div>
				<div className="prc-plan__units">{Object.keys(unitSelect).length ? <Select {...unitSelect} testId="prc-select-units" /> : null}</div>
				<Button primary={true} onClick={onButtonClick} testId="prc-button-choose-plan">
					{buttonLabel}
				</Button>
			</div>

			<div className="prc-plan__information">
				{loading ? (
					<span className="skeleton__elem skeleton__elem--text-short"></span>
				) : (
					<p className="prc-plan__description" dangerouslySetInnerHTML={{ __html: description }} />
				)}
				{featureListItems.length || loading ? (
					<div className="prc-plan__features">
						<p>{featureHeading}</p>
						{loading ? (
							<ul className="skeleton skeleton--list">
								<li className="skeleton__elem skeleton__elem--text-long"></li>
								<li className="skeleton__elem skeleton__elem--text-short"></li>
								<li className="skeleton__elem skeleton__elem--text-long"></li>
								<li className="skeleton__elem skeleton__elem--text-short"></li>
							</ul>
						) : (
							<List items={featureListItems} useCheckmarks={true} />
						)}
					</div>
				) : null}
				{bottomLink.href && (
					<div className="prc-plan__feature-link">
						<Link href={bottomLink.href} onClick={bottomLink.onClick ? bottomLink.onClick : () => {}}>
							{bottomLink.label}
						</Link>
					</div>
				)}
			</div>
		</div>
	);
}

Plan.propTypes = {
	bottomLink: PropTypes.object,
	buttonLabel: PropTypes.string,
	description: PropTypes.string,
	featureHeading: PropTypes.string,
	featureListItems: PropTypes.array,
	highlight: PropTypes.string,
	loading: PropTypes.bool,
	onButtonClick: PropTypes.func,
	price: PropTypes.string,
	priceExplanation: PropTypes.string,
	priceInterval: PropTypes.string,
	pricePerUnit: PropTypes.string,
	unitSelect: PropTypes.object,
};
